var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BigNumber, ethers, utils } from 'ethers';
import { getPropertiesFromTokenId, PALETTE_TYPES, COLORS, GRID_LAYOUTS, CELL_TYPES, MARGIN_OFFSETS } from './properties';
export var MAX_SUPPLY = 500;
export var LAUNCH_TIMESTAMP = 1666717200;
export var AUCTION_END_TIMESTAMP = 1666724400;
export var STARTING_PRICE_PER_TOKEN_MINT = utils.parseUnits('2.0', 'ether');
export var AUCTION_STAGES = 4;
export var PHYSICAL_PRICE = utils.parseUnits('1.0', 'ether');
export var SPECIALS_TARGET = 50;
var description1 = "Stencils is a series of 500 unique generative artworks with the option to receive a corresponding physical multi-layered artwork. Each are made with a laser cutter directly from the artist's studio.";
var description2 = 'Stencils is repetition and motion, its expression is the result of oscillation and layered rotation. Four layers of varying colors, each with the same grid of oscillated open cells, are rotated 90 degrees on top of each other. With each rotation the layers form symmetry that is heightened by one to four solid cells on each layer. An ellipse within the grid counteracts the symmetry. The layers overlap and the colors, cells and ellipse merge into an asymmetrical balance with an unexpected expression. It is a work of architectural tectonics. It embodies the science and art of digital modeling, both in relation to method and artistic expression. It refers not only to the activity of modeling the work, but rather to the activity that raises the modeling to an art form.';
var description3 = 'Once claimed, the laser-cut artwork and the NFT and are not linked together; the NFT can continue to be transferred on a secondary market without the laser-cut artwork changing hands.';
var description4 = 'The laser-cut artwork is unique, one per minted NFT. Physical artwork details: 38x38cm, 350g/㎡ Doosung Paper, 100% recycled and eco-friendly paper certified by FSC';
export var DESCRIPTION = description1 + '\n\n' + description2 + '\n\n' + description3 + '\n\n' + description4;
var settingsDescription = 'Settings:\n\n\
Press “s” to download image (PNG).\n\n\
Double-click/tap to explode and merge layers in Live Mode.\n\n\
Press "v" to start a video export (MP4) in Live Mode, and press "v" again to end the clip.';
export function getPhysicalCopyInfo(tokenId, contract) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!contract.callStatic) return [3 /*break*/, 2];
                    return [4 /*yield*/, contract.callStatic.physicalCopyRecipient(tokenId.toString())];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [4 /*yield*/, contract.methods.physicalCopyRecipient(tokenId.toString()).call()];
                case 3: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function getTokenFromId(tokenId, options) {
    var _a = options !== null && options !== void 0 ? options : {}, _b = _a.imageUri, imageUri = _b === void 0 ? '' : _b, _c = _a.generatorUri, generatorUri = _c === void 0 ? '' : _c, _d = _a.imageExtension, imageExtension = _d === void 0 ? 'png' : _d, _e = _a.rootUri, rootUri = _e === void 0 ? '' : _e, includePhysicalCopyInfo = _a.includePhysicalCopyInfo, contract = _a.contract;
    var id = BigNumber.from(tokenId.toString());
    if (id.gte(BigNumber.from(1).shl(42)))
        throw 'Invalid Token Id';
    var properties = getPropertiesFromTokenId(Number(tokenId));
    var name = "Stencils #".concat(properties.sequence.toString());
    var description = description1 + '\n\n' + properties.description + '\n\n' + settingsDescription;
    var attributes = [
        { trait_type: 'Grid Layout', value: properties.gridLayout },
        { trait_type: 'Cell Type', value: properties.cellType },
        { trait_type: 'Has Window', value: properties.hasWindow ? 'Yes' : 'No' },
        { trait_type: 'Has Hatches', value: properties.hasHatches ? 'Yes' : 'No' },
        { trait_type: 'Palette', value: properties.palette },
        { trait_type: 'Layer 1 Color', value: properties.colors[0] },
        { trait_type: 'Layer 2 Color', value: properties.colors[1] },
        { trait_type: 'Layer 3 Color', value: properties.colors[2] },
        { trait_type: 'Layer 4 Color', value: properties.colors[3] },
        { trait_type: 'Background Color', value: properties.colors[4] },
        { trait_type: 'Margin Offset', value: properties.marginOffset },
        { trait_type: 'Solid Count', value: properties.solidCount, display_type: 'number' },
        { trait_type: 'Solid Position 1', value: properties.solidPositions[0], display_type: 'number' },
    ];
    if (properties.solidCount > 1) {
        attributes.push({ trait_type: 'Solid Position 2', value: properties.solidPositions[1], display_type: 'number' });
    }
    if (properties.solidCount > 2) {
        attributes.push({ trait_type: 'Solid Position 3', value: properties.solidPositions[2], display_type: 'number' });
    }
    if (properties.solidCount > 3) {
        attributes.push({ trait_type: 'Solid Position 4', value: properties.solidPositions[3], display_type: 'number' });
    }
    if (properties.frequency != undefined) {
        attributes.push({ trait_type: 'Frequency', value: properties.frequency, display_type: 'number' });
    }
    if (properties.hasWindow) {
        attributes.push({ trait_type: 'Window Position', value: properties.windowPosition, display_type: 'number' });
        attributes.push({ trait_type: 'Window Size', value: properties.windowSize, display_type: 'number' });
    }
    if (!isNaN(properties.solidsInMargin)) {
        attributes.push({ trait_type: 'Solids in Margin', value: properties.solidsInMargin, display_type: 'number' });
    }
    var token = {
        id: id.toString(),
        name: name,
        description: description,
        metadata: {
            attributes: attributes,
            name: name,
            description: description,
            background_color: 'ffffff',
            image: "".concat(imageUri, "/").concat(id, ".").concat(imageExtension),
            generator_url: "".concat(generatorUri, "?tokenId=").concat(id),
            animation_url: "".concat(generatorUri, "?tokenId=").concat(id),
            live_url: "".concat(generatorUri, "?tokenId=").concat(id, "&animate=true"),
            artist: 'David Mrugala',
            external_url: "".concat(rootUri, "/").concat(id.toString()),
        },
    };
    if (!includePhysicalCopyInfo)
        return token;
    if (!contract)
        throw 'Web3 or Ethers contract must be defined in options when using includePhysicalCopyInfo.';
    return getPhysicalCopyInfo(tokenId, contract).then(function (physicalCopyRecipient) {
        if (physicalCopyRecipient === ethers.constants.AddressZero) {
            token.metadata.attributes.push({ trait_type: 'Laser-Cut Physical Copy Available', value: 'Yes' });
        }
        else {
            token.metadata.attributes.push({ trait_type: 'Laser-Cut Physical Copy Available', value: 'No' });
            token.metadata.attributes.push({ trait_type: 'Laser-Cut Physical Copy Recipient', value: physicalCopyRecipient });
        }
        return Object.assign(token, { physicalCopyRecipient: physicalCopyRecipient });
    });
}
export function getContractMetadata(imageUri, imageExtension, feeBasisPoints, feeRecipient, assetGeneratorHash) {
    if (imageUri === void 0) { imageUri = ''; }
    if (imageExtension === void 0) { imageExtension = 'png'; }
    if (feeBasisPoints === void 0) { feeBasisPoints = 0; }
    if (feeRecipient === void 0) { feeRecipient = ''; }
    if (assetGeneratorHash === void 0) { assetGeneratorHash = ''; }
    return {
        name: 'Stencils',
        description: DESCRIPTION,
        image: "".concat(imageUri, "/Stencils.").concat(imageExtension),
        external_link: 'faction.art/project/stencils',
        seller_fee_basis_points: feeBasisPoints,
        fee_recipient: feeRecipient,
        artist: 'David Mrugala',
        asset_generator_hash: assetGeneratorHash,
    };
}
function buildAuctionInfo() {
    var auctionStages = [];
    for (var i = 1; i <= AUCTION_STAGES; ++i) {
        auctionStages.push({
            price: i === 1 ? STARTING_PRICE_PER_TOKEN_MINT : auctionStages[i - 2].price.div(2),
            physicalCopyIncluded: i === 1 || i === 2,
            specialIncluded: i === 1,
        });
    }
    return {
        auctionStages: auctionStages,
        minimumPrice: auctionStages[auctionStages.length - 1].price,
        stageDuration: (AUCTION_END_TIMESTAMP - LAUNCH_TIMESTAMP) / AUCTION_STAGES,
        startTime: LAUNCH_TIMESTAMP,
    };
}
export var AUCTION_INFO = buildAuctionInfo();
export var ATTRIBUTES = [
    { name: 'Laser-Cut Physical Copy Available', values: ['Yes', 'No'] },
    { name: 'Palette', values: PALETTE_TYPES },
    { name: 'Grid Layout', values: GRID_LAYOUTS },
    { name: 'Cell Type', values: CELL_TYPES },
    { name: 'Has Window', values: ['Yes', 'No'] },
    { name: 'Has Hatches', values: ['Yes', 'No'] },
    { name: 'Solid Count', min: BigInt(1), max: BigInt(4) },
    { name: 'Layer 1 Color', values: COLORS },
    { name: 'Layer 2 Color', values: COLORS },
    { name: 'Layer 3 Color', values: COLORS },
    { name: 'Layer 4 Color', values: COLORS },
    { name: 'Background Color', values: COLORS },
    { name: 'Margin Offset', values: MARGIN_OFFSETS },
    { name: 'Frequency', min: BigInt(-720), max: BigInt(720), optional: true },
    { name: 'Solids In Margin', min: BigInt(1), max: BigInt(4), optional: true },
    { name: 'Window Size', min: BigInt(400), max: BigInt(600), optional: true },
    { name: 'Window Position', min: BigInt(0), max: BigInt(288), optional: true },
    { name: 'Solid Position 1', min: BigInt(0), max: BigInt(255) },
    { name: 'Solid Position 2', min: BigInt(0), max: BigInt(255), optional: true },
    { name: 'Solid Position 3', min: BigInt(0), max: BigInt(255), optional: true },
    { name: 'Solid Position 4', min: BigInt(0), max: BigInt(255), optional: true },
];
//# sourceMappingURL=StencilsHelpers.js.map